import { ArrowUpRight } from "lucide-react";
import { ASSETS } from "@/lib/site";

const SERVICES = [
  {
    tag: "01 Keynotes",
    title: "High-impact keynote speaking",
    body: "Story-driven keynotes for conferences, district kickoffs, and student assemblies that move audiences from passive to purposeful.",
    bullets: ["Conferences", "District Kickoffs", "Student Assemblies", "Convocations"],
    image: ASSETS.action3,
    pos: "center",
  },
  {
    tag: "02 Workshops",
    title: "Interactive workshops",
    body: "Hands-on sessions for educators, students, and families with practical tools they can use Monday morning.",
    bullets: ["Leadership", "Communication", "Accountability", "Relationships"],
    image: ASSETS.studentAssembly,
    pos: "center",
  },
  {
    tag: "03 Professional Development",
    title: "Sustained professional development",
    body: "Multi-session PD on retention, climate, and student-staff relationships — built for measurable culture change.",
    bullets: ["Teacher Retention", "School Culture", "SEL Integration", "Coaching"],
    image: ASSETS.pd,
    pos: "center",
  },
  {
    tag: "04 Virtual Presentations",
    title: "Virtual presentations & webinars",
    body: "Remote sessions designed for engagement — staff PD days, family nights, and student programs at any distance.",
    bullets: ["Live Webinars", "Virtual Assemblies", "Family Nights", "Staff PD"],
    image: ASSETS.district,
    pos: "center",
    contain: true,
  },
];

export default function Services() {
  return (
    <section id="services" className="relative bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="eyebrow text-gold">Services</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-3 font-bold tracking-tight">
            Four ways to <span className="italic font-medium">partner.</span>
            <span className="block text-navy/60">One mission: growth.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className="group relative bg-white border border-[hsl(var(--line))] overflow-hidden hover:border-navy/40 transition-all duration-500"
            >
              <div className={`aspect-[16/9] overflow-hidden ${s.contain ? 'bg-navy' : ''}`}>
                <img
                  src={s.image}
                  alt={s.title}
                  style={{ objectPosition: s.pos }}
                  className={`w-full h-full ${s.contain ? 'object-contain' : 'object-cover'} group-hover:scale-105 transition-transform duration-[1200ms]`}
                />
              </div>
              <div className="p-7 md:p-8">
                <div className="flex items-center justify-between">
                  <span className="eyebrow text-gold">{s.tag}</span>
                  <ArrowUpRight size={18} className="text-navy/40 group-hover:text-gold transition-colors" />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-navy mt-3 font-semibold leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[14px] text-navy/65 leading-relaxed">{s.body}</p>
                <div className="mt-5 flex flex-wrap gap-x-4 gap-y-1">
                  {s.bullets.map((b) => (
                    <span key={b} className="text-[12px] text-navy/55 tracking-wide">
                      · {b}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
